module.exports = __webpack_public_path__ + "img/member_rights_icon_431005.db7505b2.png";